import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/cascade';

import { ITheme, mediaQuery } from '../../../styles';
import { MENU_COLLAPSE_BREAKPOINT } from '../SingleToolNavigation';

export default createUseStyles(({ breakpoints }: ITheme) => ({
  root: {
    backgroundColor: 'var(--x-bg-5)',
  },
  mainContainer: {
    padding: [0, 40, 24, 40],
    display: 'flex',
    gap: Spacings.s24,

    [mediaQuery(breakpoints.tablet)]: {
      padding: [0, 0, 24, 0],
    },
  },
  mainContainerContent: {
    flex: 1,
    minWidth: 0,
  },
  mainContent: {
    display: 'flex',
  },
  mainContentSidebar: {
    flex: '205px 0 0',
    paddingTop: 32,

    [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
      display: 'none',
    },
  },
  mainContentResults: {
    flex: 1,
    minWidth: 0,
    position: 'relative',
  },
  mainContentBar: {
    zIndex: 10,
    position: 'sticky',
    padding: [12, 0, 14, 0],
    backgroundColor: 'var(--x-bg-5)',
  },
  mainContentBarContent: {
    minHeight: 36,
    width: '100%',
    display: 'flex',
    paddingInline: 16,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  mainContentSidebarSticky: {
    top: 300,
    marginBottom: 32,
    position: 'sticky',

    [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
      top: 197,
    },
  },
  landing: {
    background: '#ffffff',
    paddingTop: 90,
  },
}));
